import React from 'react';
import { DialogWithBody } from 'MoshtixShared/component-dialog/src/dialog-with-body';
import { A, Div, P } from 'MoshtixShared/component-element';

interface TermsDialogProps {
  show: boolean;
  onClose: () => void;
  linkCss?: Record<string, unknown>;
}
const TermsUrl = 'https://moshtix.com.au/v2/termsandconditions';

const TermsDialog: React.FC<TermsDialogProps> = ({ show, onClose, linkCss = {} }: TermsDialogProps) => (
  <DialogWithBody
    closeWithEsc
    id="terms-dialog"
    show={show}
    title="Ticket Assign Terms"
    onCloseClick={onClose}
    hideButtonContent
    headerCss={{ borderBottom: 'none' }}
    containerDialogCss={{ verticalAlign: 'middle' }}
  >
    <Div>
      <P>
        By using Ticket Assign to allocate or accept a ticket, you agree to the following:<br/><br/>
        Ticket Assign allows a ticket purchaser (&quot;Purchaser&quot;) to allocate another person (&quot;Recipient&quot;) with access to a ticket for event entry. Ticket Assign provides the Recipient with a personal, revocable right to use the ticket for entry only and does not transfer ownership. The Purchaser remains the legal owner of the ticket and the agreement for the purchase of the ticket (including all associated rights and obligations) remains with the Purchaser.<br/><br/>
        Once access is accepted by the Recipient, the ticket will be reissued with a new barcode to the Recipient and will not be accessible in the Purchaser&apos;s account. The Purchaser may revoke the Recipient&apos;s access at any time before the ticket is scanned for entry. If access is revoked, the Recipient will no longer be able to use the ticket.<br/><br/>
        The Purchaser is responsible for notifying the Recipient of any revocation and for any arrangement between them in relation to the ticket. Ticket Assign does not constitute a resale facility and Moshtix is not responsible for, and will not be involved in, any disputes between a Purchaser and a Recipient.<br/><br/>
        Each ticket is valid for one entry only and remains subject to the <A href={TermsUrl} css={linkCss}>Moshtix Terms and Conditions</A> and any applicable event or venue conditions. The Purchaser and the Recipient must comply with those terms and conditions.<br/><br/>
        If an event is cancelled, postponed or rescheduled, only the Purchaser is entitled to any applicable refund or remedy. Moshtix will communicate with the Purchaser in relation to the ticket and event.<br/><br/>
        To the extent permitted by law, Moshtix may cancel or invalidate any ticket (including a ticket subject to Ticket Assign) if it reasonably suspects a breach of applicable terms or fraud.<br/><br/>
        To the extent permitted by law (including the Australian Consumer Law and New Zealand consumer law), any liability in connection with a ticket is owed to the Purchaser and not to any Recipient. Nothing in these terms excludes any rights under applicable consumer law.<br/><br/>
        These terms operate in conjunction with, and are subject to, the <A href={TermsUrl} css={linkCss}>Moshtix Terms and Conditions</A>.<br/><br/> 
        </P>
    </Div>
  </DialogWithBody>
);

export default TermsDialog;
